"use client";

import React from "react";
import Image from "next/image";
import chefImg from "@/assets/whymsu/topmarch.webp";

const Studyinsikkim = () => {
    return (
        <section className="w-full bg-white ">
            <div className="">
                <div className="mb-6 md:mb-8 max-w-4xl">
                    <h2 className="text-xl md:text-[42px] font-bold mb-2 mt-2 md:mt-4 lg:mt-8"
                        style={{ fontFamily: "saans-bold" }}
                    >
                        Study in Sikkim
                    </h2>
                    <p
                        className="text-xs md:text-[18px] leading-snug"
                        style={{ fontFamily: "saans-regular" }}
                    >
                        A peaceful learning destination that nurtures focus, skills and personal growth

                    </p>
                </div>

                <div className="w-full">
                    <div className="grid grid-cols-1  xl:grid-cols-[1fr_1fr] border border-slate-200">
                        <div className="relative h-auto bg-slate-200 order-1 md:order-2">
                            <Image
                                src={chefImg}
                                alt="Student during practical evaluation in a kitchen or lab setting"
                                fill
                                className="object-cover"
                                priority
                            />
                        </div>


                        <div className="bg-[#007ac3] text-white px-6 md:px-14 py-10 md:py-24 flex flex-col justify-between order-2 md:order-1">
                            <div className="max-w-xl space-y-4">
                                <p
                                    className="text-[11px] md:text-[16px] leading-relaxed"
                                    style={{ fontFamily: "saans-regular" }}
                                >
                                    Nestled in the serene Himalayas, Medhavi Skills University’s Sikkim campus offers a truly
                                    immersive learning experience rooted in nature, culture and personal growth. Sikkim,
                                    known for its harmony in diversity, peaceful environment, breathtaking beauty and deep
                                    spirituality, provides an ideal setting for holistic development. Students thrive in a
                                    calm yet vibrant atmosphere enriched by clean air, lush landscapes and a community that
                                    values respect, sustainability and progress. Learning here extends beyond classrooms shaped
                                    by rich traditions, cultural exchange and forward-looking practices. With Sikkim’s paperless
                                    systems and mindful lifestyle, students are encouraged to discover themselves, explore their
                                    passions and live with purpose in a uniquely peaceful state.
                                </p>
                            </div>

                            {/* <button onClick={() => window.open("/")}
                                className="group mt-6 inline-flex items-center cursor-pointer w-[280px] justify-center bg-[#081E2D] text-white text-[11px] md:text-sm font-medium px-4 py-2 md:px-6 md:py-3"
                                style={{ fontFamily: "saans-bold" }}
                            >
                                <span>Know more about MSU</span>
                                <ArrowUpRight
                                    className="ml-2 rotate-45 group-hover:-rotate-0 h-6 w-6  transition-transform duration-300 "
                                    strokeWidth={2.2}
                                />
                            </button> */}
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Studyinsikkim;
